import HistoryReportPageComponent from "../pages/historyReport";
import withAuth from "../../hoc/withAuth";
import withLineInit from "../../hoc/lineInit";

const HistoryReportPage = () => {
  return (
    <>
      <HistoryReportPageComponent line_oa="fda-people" />
    </>
  );
};

export default withLineInit(
  withAuth(HistoryReportPage, "fda-people"),
  "fda-people"
);
